module.exports = __webpack_public_path__ + "img/hashtag.e1886132.svg";